import { render, staticRenderFns } from "./MenuCategory.vue?vue&type=template&id=0ecb5d02&scoped=true&"
import script from "./MenuCategory.vue?vue&type=script&lang=js&"
export * from "./MenuCategory.vue?vue&type=script&lang=js&"
import style0 from "./MenuCategory.vue?vue&type=style&index=0&id=0ecb5d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb5d02",
  null
  
)

export default component.exports